import LeavesStack from './LeavesStack';

export default LeavesStack;
